import { EPSILON } from 'chart-constants'
import * as d3 from 'd3-selection'

/*
 * Draws pie level labels. This is similar to an x-axis and we could probably
 * rework x-axis code to include this logic and layout.
 */
export default (selection, grid, chart) => {
  selection.each(function (d) {
    let showing = chart.datum().axes.bottom.labels
      , breakdown = d.breakdown
      , group = d3.select(this)
                  .selectAll('g.pie-labels').data(showing ? [grid.blocks] : [])
      , enter = group.enter()
                     .append('g')
                     .attr('class', 'pie-labels')

    group = group.merge(enter)
                 .style('opacity', EPSILON)

    let labels = group.selectAll('g.pie-label')
                      .data(d => {
                        if (!breakdown || !breakdown.range.length) {
                          return []
                        }

                        return d.map(block => {
                          let rangeId = block.range.id

                          return {
                            rangeId: block.range.id,
                            title: block.range.title,
                            subtitle: block.range.subtitle,
                            layout: block.dimensions
                          }
                        })
                      }, d => d.rangeId)
                      .join('g')
                         .attr('class', 'pie-label')
                          .attr('transform', d => `translate(${d.layout.x + d.layout.width / 2},${d.layout.y + d.layout.height})`)

    labels.selectAll('text')
          .data(d => [d])
          .join('text')
          .text(d => d.title)
          .attr('dy', '8px')

    group.exit().remove()

    chart.defaultTransition.end().then(() => {
      group.style('opacity', 1)
    }).catch(() => {
      // interrupted transition, ignore
    })
  })
}
